<template>
    <el-dialog
        :title="setId?'编辑居民数据':'新增居民数据'"
        :visible.sync="residentDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="1200px"
        center>
        <el-form :model="residentForm" :rules="rules" ref="residentForm" label-width="120px">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="社区：" prop="project">
                        <el-select v-model="residentForm.project" placeholder="请选择社区" style="width: 100%;" v-if="user.power === 3" @change="projectChange">
                            <el-option
                                v-for="item in projectList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input :value="residentForm.project" readonly placeholder="请选择社区" v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="小区：" prop="communityId">
                        <el-select v-model="residentForm.communityId" placeholder="请选择小区" style="width: 100%" @change="twoChange">
                            <el-option
                                v-for="item in communityList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="flex align-center">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item class="basis-sm" label="楼门户：" prop="building">
                                <el-select v-model="residentForm.building" placeholder="请选择楼栋">
                                    <el-option
                                        v-for="item in buildingList"
                                        :key="item.id"
                                        :label="item.building_name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item class="basis-xsm" prop="unit" label-width="0">
                                <el-select v-model="residentForm.unit" placeholder="请选择单元">
                                    <el-option
                                        v-for="item in unitList"
                                        :key="item.id"
                                        :label="item.element_name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item class="basis-xsm" prop="room" label-width="0">
                                <el-select v-model="residentForm.room" placeholder="请选择房间">
                                    <el-option
                                        v-for="item in roomList"
                                        :key="item.id"
                                        :label="item.room_name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="姓名：" prop="name">
                        <el-input v-model="residentForm.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="手机号：" prop="phone">
                        <el-input v-model="residentForm.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="性别：" prop="sex">
                        <el-select v-model="residentForm.sex" class="w-all" placeholder="请选择">
                            <el-option
                                v-for="item in sexList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="民族：" prop="nation">
                        <el-select v-model="residentForm.nation" class="w-all" placeholder="请选择">
                            <el-option
                                v-for="item in nationList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="身份证：" prop="idCard">
                        <el-input v-model="residentForm.idCard" placeholder="请输入身份证"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="状态：" prop="live">
                        <el-select v-model="residentForm.live" class="w-all" placeholder="请选择">
                            <el-option
                                v-for="item in liveList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="与户主关系：" prop="relation">
                        <el-select v-model="residentForm.relation" class="w-all" placeholder="请选择">
                            <el-option
                                v-for="item in relationList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="户口性质：" prop="nature">
                        <el-select v-model="residentForm.nature" class="w-all" placeholder="请选择">
                            <el-option
                                v-for="item in natureList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="户籍地：" prop="register">
                        <el-input v-model="residentForm.register" placeholder="请输入户籍地"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="健康状态：">
                        <el-select v-model="residentForm.health" class="w-all" placeholder="请选择">
                            <el-option
                                v-for="item in health"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="标签：">
                        <el-select v-model="residentForm.tags" class="w-all" placeholder="请选择" multiple>
                            <el-option
                                v-for="item in tags"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="备注：" prop="desc">
                        <el-input type="textarea" v-model="residentForm.desc" placeholder="请输入备注"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('residentForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('residentForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import {getYuanGongGuanLiXiaoQu} from "@/api/login";
// import rules from '@/utils/rules'
import {health, live, nation, nature, optionList, relation, sex} from "@/utils/utils";
import {getDanYuanList, getFangJianList, getLouHaoList, getXiangMuList, getXiaoQuList} from "@/api/common";
import {juMinAdd} from "@/api/resident";
import {juminTagList} from "@/api/weilao";

export default {
    name: "residentDialog",
    props: {
        residentDialog: {
            type: Boolean,
            default: false
        },
        setId: {
            type: Number,
            default() {
                return 0;
            }
        },
        setItem: {
            type: Object
        }
    },
    data() {
        return {
            isclear: false,
            communityList: [],
            buildingList: [],
            unitList: [],
            roomList: [],
            projectList: [],
            tags: [],
            sexList: optionList(false, sex),
            health: optionList(false, health),
            nationList: optionList(false, nation),
            liveList: optionList(false, live),
            relationList: optionList(false, relation),
            natureList: optionList(false, nature),
            residentForm: {
                project: '',
                projectId: '',

                communityId: '',
                building: '',
                unit: '',
                room: '',
                name: '',
                sex: '',
                nation: '',
                idCard: '',
                phone: '',
                live: '',
                relation: '',
                nature: '',
                register: '',
                desc: '',
                health: '',
                tags: [],
            },
            rules: {
                project: [{required: true, message: '请选择社区', trigger: 'change'}],
                communityId: [{required: true, message: '请选择小区', trigger: 'change'}],
                building: [{required: true, message: '请选择楼栋', trigger: 'change'}],
                unit: [{required: true, message: '请选择单元', trigger: 'change'}],
                room: [{required: true, message: '请选择房间号', trigger: 'change'}],
                name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                sex: [{required: true, message: '请选择性别', trigger: 'change'}],
                // nation: [{required: true, message: '请选择民族', trigger: 'change'}],
                // idCard: rules.idCard,
                // phone: rules.phone2,
                // live: [{required: true, message: '请选择状态', trigger: 'change'}],
                // relation: [{required: true, message: '请选择与户主关系', trigger: 'change'}],
                // nature: [{required: true, message: '请选择户口性质', trigger: 'change'}],
                // register: [{required: true, message: '请输入户籍地', trigger: 'blur'}],
            }
        }
    },
    created() {
        if (this.user.power === 6)this.getComminity()
        if (this.user.power === 3)this.getXiangMuList()
        this.getTags()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await juMinAdd(
                this.residentForm.projectId,
                this.residentForm.communityId,
                this.residentForm.building,
                this.residentForm.unit,
                this.residentForm.room,
                this.residentForm.name,
                this.residentForm.sex,
                this.residentForm.nation,
                this.residentForm.idCard,
                this.residentForm.phone,
                this.residentForm.live,
                this.residentForm.relation,
                this.residentForm.nature,
                this.residentForm.register,
                this.residentForm.desc,
                this.residentForm.health,
                this.residentForm.tags.join(','),
                this.setId ? this.setId : '',
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        },
        //  获取小区
        async getXiaoQuList() {
            let _data = await getXiaoQuList(this.residentForm.projectId)
            this.communityList = _data.data
        },
        //  获取房间
        async getRoom() {
            let _data = await getFangJianList(this.residentForm.unit)
            this.roomList = _data.data
            this.isclear = true
        },
        //  获取单元
        async getUnit() {
            let _data = await getDanYuanList(this.residentForm.building)
            this.unitList = _data.data
        },
        //  获取楼栋
        async getBuild() {
            let _data = await getLouHaoList(this.residentForm.communityId)
            this.buildingList = _data.data
        },
        //  获取标签
        async getTags() {
            let _data = await juminTagList()
            this.tags = _data.data
        },
        async getXiangMuList() {
            let _data = await getXiangMuList()
            this.projectList = _data.data
        },

        //  获取当前员工管理的社区和小区
        async getComminity() {
            let _data = await getYuanGongGuanLiXiaoQu(this.user.id)
            this.residentForm.project = _data.data.xiangmu_name
            this.residentForm.projectId = _data.data.xiangmu_id
            this.getXiaoQuList()
        },

        projectChange(e) {
            this.residentForm.projectId = e
            this.residentForm.communityId =''
            this.residentForm.building = ''
            this.residentForm.unit = ''
            this.residentForm.room = ''
            this.getXiaoQuList()
        } ,
        twoChange(e) {
            this.residentForm.communityId = e
            this.residentForm.building = ''
            this.residentForm.unit = ''
            this.residentForm.room = ''
            this.getBuild()
        }
    },
    watch: {
        setItem() {
            if (this.residentDialog) {
                this.isclear = false

                // this.community = this.setItem.xiaoqu_name
                // this.communityId = this.setItem.xiaoqu_id
                if (this.setId) {
                    this.residentForm = {
                        project : this.setItem.xiangmu_name,
                        projectId : this.setItem.xiangmu_id,
                        communityId: this.setItem.xiaoqu_id,
                        building: this.setItem.lou_id,
                        unit: this.setItem.men_id,
                        room: this.setItem.hu_id,
                        name: this.setItem.name,
                        sex: this.setItem.sex,
                        nation: this.setItem.minzu,
                        idCard: this.setItem.id_card,
                        phone: this.setItem.phone,
                        live: this.setItem.status,
                        relation: this.setItem.yuhuzhuguanxi,
                        nature: this.setItem.hukouxingzhi,
                        register: this.setItem.hujidi,
                        health: this.setItem.health ? Number(this.setItem.health) : '',
                        tags: this.setItem.tags ? this.setItem.tags.split(',').map(Number) : [],
                        desc: this.setItem.beizhu,
                    };
                    this.$nextTick(() => {
                        this.$refs['residentForm'].clearValidate();
                    });
                }else {
                    this.$nextTick(() => {
                        this.$refs['residentForm'].resetFields();
                    });
                }

            }

        },
        // 'residentForm.communityId'() {
        //   if (this.residentForm.communityId) {
        //
        //   }
        // },
        'residentForm.building'() {
            if (this.residentForm.building) {
                this.getUnit()
                if (this.isclear) {
                    this.residentForm.unit = ''
                    this.residentForm.room = ''
                    this.$nextTick(() => {
                        this.$refs.residentForm.clearValidate();
                    })
                }

            }


        },
        'residentForm.unit'() {
            if (this.residentForm.unit) {
                this.getRoom()
                if (this.isclear) {
                    this.residentForm.room = ''
                    this.$nextTick(() => {
                        this.$refs.residentForm.clearValidate();
                    })
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
